import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";

const defaultGallery = [IMAGES.ambiance, IMAGES.eyes, IMAGES.reception, IMAGES.brow, IMAGES.manicure, IMAGES.bath];
const alts = ["Espace de soin apaisant", "Beauté du regard, rehaussement de cils", "Accueil de l'institut", "Sourcils et regard", "Pédicure et soin des mains", "Ambiance bien-être"];

export default function Institute({ images = {} }) {
  const { t } = useLang();
  const i = t.institute;
  const gallery = (images?.gallery && images.gallery.length ? images.gallery : defaultGallery);
  const shots = gallery.slice(0, 6).map((src, idx) => ({
    src: src || defaultGallery[idx],
    alt: alts[idx] || "L'institut",
    span: idx === 0 ? "row-span-2" : "",
  }));

  return (
    <section id="institute" className="bg-cream py-20 md:py-32 scroll-mt-20" data-testid="institute-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs tracking-[0.22em] uppercase text-gold font-medium">{i.overline}</span>
            <h2 className="mt-4 font-serif text-3xl md:text-5xl text-ink">{i.title}</h2>
            <p className="mt-4 text-taupe text-base md:text-lg leading-relaxed">{i.subtitle}</p>
          </div>
        </Reveal>

        {/* Mobile: horizontal scroll carousel */}
        <div className="mt-12 md:hidden -mx-5 px-5 flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4" data-testid="institute-carousel">
          {shots.map((sh, idx) => (
            <div key={idx} className="snap-center shrink-0 w-[75%] aspect-[3/4] overflow-hidden rounded-2xl ring-1 ring-gold/20">
              <img src={sh.src} alt={sh.alt} className="h-full w-full object-cover" loading="lazy" />
            </div>
          ))}
        </div>

        {/* Desktop: bento mosaic */}
        <div className="mt-12 hidden md:grid grid-cols-4 grid-rows-2 gap-4 auto-rows-[220px]" data-testid="institute-grid">
          {shots.map((sh, idx) => (
            <Reveal key={idx} delay={idx * 0.06} className={`${sh.span || ""} ${idx === 0 ? "col-span-1" : ""}`}>
              <div className={`h-full overflow-hidden rounded-2xl ring-1 ring-gold/20 ${sh.span ? "min-h-[456px]" : ""}`}>
                <img src={sh.src} alt={sh.alt} className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" loading="lazy" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
